var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkBlock2Ic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.251 45.2769V43.2154L28.0621 32.917L22.5992 38.4387L37.529 53.5291L38.251 52.7993V52.1973L36.807 50.7378L33.5943 47.4935L33.3867 47.2837L24.6387 38.4387L28.0621 34.9785L38.251 45.2769Z",
    fill: "#1D4B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8101 11.119V41.759L29.0819 33.9477L28.0621 32.917L27.0423 33.9477L23.6189 37.4079L22.5992 38.4387L23.6189 39.4694L32.3669 48.3145L32.5745 48.5243L35.7873 51.7686L36.8101 52.8024V69.2307C33.134 67.5614 29.6956 65.4117 26.576 62.8363C16.8835 54.8183 11.9711 43.9452 11.9711 30.5179V11.119H36.8131M38.251 9.66256H10.5271V30.5149C10.5271 44.4073 15.62 55.6545 25.6615 63.9613C29.0518 66.7617 32.8001 69.0665 36.8071 70.8209C37.2854 71.0307 37.7667 71.2314 38.251 71.426V52.1973L36.8071 50.7378L33.5943 47.4935L33.3867 47.2837L24.6387 38.4387L28.0621 34.9785L38.251 45.2769V9.66256Z",
    fill: "#1D4B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4765 9.66864V30.521C69.4765 44.3283 64.4437 55.5328 54.5165 63.8215C51.0811 66.6827 47.2697 69.0391 43.1935 70.8239C42.7182 71.0307 42.2369 71.2344 41.7526 71.426V48.2294L59.7178 30.071L55.2746 25.58L43.1935 37.788L41.7526 39.2444V9.66864H69.4765Z",
    fill: "#1D4B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.251 5.5V65.2769L36.8071 63.8175V5.5H38.251Z",
    fill: "#1D4B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.251 52.1973V74.5H36.8071V50.7378L38.251 52.1973Z",
    fill: "#1D4B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9711 5.5H10.5271V27.6689H11.9711V5.5Z",
    fill: "#1D4B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.251 9.66256H7.04658V11.119H38.251V9.66256Z",
    fill: "#1D4B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7778 30.6068L24.7589 31.6367L35.4776 42.4706L36.4965 41.4407L25.7778 30.6068Z",
    fill: "#1D4B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3062 30.6511L20.4043 40.6594L21.4232 41.6893L31.3251 31.6809L30.3062 30.6511Z",
    fill: "#1D4B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 35.0996L20.3145 36.1295L30.8438 46.7721L31.8627 45.7422L21.3334 35.0996Z",
    fill: "#1D4B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.957 9.66256H41.7526V11.119H72.957V9.66256Z",
    fill: "#1D4B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1935 5.5V37.788L41.7526 39.2444V5.5H43.1935Z",
    fill: "#1D4B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7526 48.2293L43.1935 46.7729V74.5H41.7526V48.2293Z",
    fill: "#1D4B48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.9104,
    height: 69,
    fill: "white",
    transform: "translate(7.04478 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkBlock2Ic);
export default __webpack_public_path__ + "static/media/workBlock2_ic.7fa7500f9573a3a0f08a7e2912096d0b.svg";
export { ForwardRef as ReactComponent };